<div class="m-3 is-flex is-flex-direction-column is-flex-grow-1">
  <div class="is-flex is-align-items-start mb-3 py-2 px-3" *ngIf="issues.length"
    style="background: #fff8e1; border: 1px solid #f0a500; border-radius: 4px">
    <i class="fas fa-exclamation-triangle has-text-warning-dark mt-1 mr-3"></i>
    <div>
      <strong class="is-size-7 has-text-dark">
        {{ 'BUSINESS_ISSUES' | translate : { defaultValue: 'Issues' } }}
      </strong>
      <div *ngFor="let item of issues" class="is-size-7 has-text-grey-dark mt-1">
        {{ item.issue.translationKey | translate : { defaultValue: item.issue.title } }}
      </div>
    </div>
  </div>

  <app-tabset
    class="is-flex-grow-1"
    [transparent]="true"
    (tabChange)="onTabChange($event)"
  >
    <app-tab id="general" name="GENERAL" [active]="tab === 'general'">
      <general [isReadonly]="isReadonly"></general>
    </app-tab>
    <app-tab id="documents" name="DOCUMENTS" [active]="tab === 'documents'">
      <documents
        *ngIf="tab === 'documents'"
        [isReadonly]="isReadonly"
      ></documents>
    </app-tab>
    <app-tab id="gallery" name="GALLERY" [active]="tab === 'gallery'">
      <gallery *ngIf="tab === 'gallery'" [isReadonly]="isReadonly"></gallery>
    </app-tab>
    <app-tab
      id="payments"
      name="PAYMENTS"
      *ngxPermissionsOnly="['LICENSE_TAB_PAYMENTS']"
      [active]="tab === 'payments'"
    >
      <payments *ngIf="tab === 'payments'" [isReadonly]="isReadonly"></payments>
    </app-tab>
  </app-tabset>

  <div class="control has-text-right mt-2" *ngIf="isReadonly">
    <a
      [routerLink]="['/licenses', 'archived']"
      class="button is-link mb-0"
      translationEditableDirective="BACK_TO_LICENSES"
      >{{ 'BACK_TO_LICENSES' | translate }}</a
    >
  </div>
</div>
